/**
 * Build Tracker pure helpers (Day 99b.4) — extracted from BuildTracker.tsx so the
 * conclusion-badge mapping and the search .or() construction are unit-testable
 * regression guards AND the single source of truth the page renders.
 */

import { escapeOrIlikeTerm } from '../../../../src/lib/postgrestEscape';

// GitHub workflow_run.conclusion is one of success / failure / cancelled /
// timed_out / action_required / neutral / skipped / stale. Human-readable labels
// per TONE §12 (a raw value falls back to itself so the badge never blanks).
const CONCLUSION_LABELS: Record<string, string> = {
  success: 'Success',
  failure: 'Failure',
  cancelled: 'Cancelled',
  timed_out: 'Timed out',
  action_required: 'Action required',
  neutral: 'Neutral',
  skipped: 'Skipped',
  stale: 'Stale',
};

export type ConclusionTone = 'success' | 'danger' | 'neutral';

// success→success, failure→danger, EVERYTHING ELSE→neutral (the DEFAULT branch,
// per UI_STANDARDS §10). The non-binary set must NOT misrender as failure.
export function conclusionTone(conclusion: string): ConclusionTone {
  if (conclusion === 'success') return 'success';
  if (conclusion === 'failure') return 'danger';
  return 'neutral';
}

export function conclusionLabel(conclusion: string): string {
  return CONCLUSION_LABELS[conclusion] ?? conclusion;
}

// Build the PostgREST .or() filter for the Build Tracker search across the three
// text columns (commit_sha / commit_message / actor). The canonical
// escapeOrIlikeTerm wraps the term in double quotes, so .or()-reserved chars —
// commas and parens, routine in conventional-commit messages ("fix(scope): …, …")
// — are matched LOSSLESSLY (a strip-based sanitizer would silently drop them).
export function buildSearchOrFilter(rawTerm: string): string {
  const t = escapeOrIlikeTerm(rawTerm.trim());
  return `commit_sha.ilike.${t},commit_message.ilike.${t},actor.ilike.${t}`;
}
